(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["sg-birthstone-landing"] && !Shopify.designMode) return;
  try {
    
(function () {
  var page = document.querySelector('[data-sg-birthstone-page]');
  if (!page || page.dataset.sgBirthstoneReady) return;
  page.dataset.sgBirthstoneReady = 'true';

  var options = Array.prototype.slice.call(page.querySelectorAll('[data-sg-birthstone-option]'));
  var jumps = Array.prototype.slice.call(page.querySelectorAll('[data-sg-birthstone-jump]'));
  var panels = Array.prototype.slice.call(page.querySelectorAll('[data-sg-birthstone-panel]'));

  function select(key) {
    options.forEach(function (item) {
      var selected = item.getAttribute('data-key') === key;
      item.classList.toggle('is-selected', selected);
      item.setAttribute('aria-pressed', selected ? 'true' : 'false');
    });
    jumps.forEach(function (item) {
      var selected = item.getAttribute('data-sg-birthstone-jump') === key;
      item.classList.toggle('is-selected', selected);
      item.setAttribute('aria-pressed', selected ? 'true' : 'false');
      if (selected && item.scrollIntoView) item.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' });
    });
    panels.forEach(function (item) {
      item.classList.toggle('is-hidden', item.getAttribute('data-sg-birthstone-panel') !== key);
    });
  }

  options.forEach(function (option) {
    option.addEventListener('click', function () { select(option.getAttribute('data-key')); });
  });
  jumps.forEach(function (jump) {
    jump.addEventListener('click', function () { select(jump.getAttribute('data-sg-birthstone-jump')); });
  });
}());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sg-header"] && !Shopify.designMode) return;
  try {
    
(function () {
  if (window.SGHeaderNavigationReady) return;
  window.SGHeaderNavigationReady = true;

  var mobileOrigin = null;
  var mobileLastFocus = null;
  var mobileSearchLastFocus = null;

  function getMobileSearch() {
    return document.getElementById('sg-mobile-search');
  }

  function getSearchOverlay() {
    return document.querySelector('[data-sg-search-overlay]');
  }

  function positionMobileSearch(search) {
    var header = document.querySelector('.sg-header');
    if (!search || !header) return;
    search.style.setProperty('--sg-mobile-search-top', Math.round(header.getBoundingClientRect().bottom) + 'px');
  }

  function syncSearchClearButton(search) {
    var input = search && search.querySelector('input[type="search"]');
    var clear = search && search.querySelector('[data-sg-search-clear]');
    if (!input || !clear) return;
    clear.disabled = !input.value;
  }

  var searchOverlay = getSearchOverlay();
  if (searchOverlay && !searchOverlay.dataset.sgSearchCloseReady) {
    searchOverlay.dataset.sgSearchCloseReady = 'true';
    searchOverlay.addEventListener('click', function (event) {
      event.stopPropagation();
      closeMobileSearch(false);
    });
  }

  function setMobileSearchExpanded(open) {
    document.querySelectorAll('[data-sg-search-toggle]').forEach(function (button) {
      button.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  function openMobileSearch(trigger) {
    var search = getMobileSearch();
    var overlay = getSearchOverlay();
    if (!search) return;

    if (!search.hidden) {
      closeMobileSearch(true);
      return;
    }
    mobileSearchLastFocus = trigger || document.activeElement;
    positionMobileSearch(search);
    search.hidden = false;
    if (overlay) {
      overlay.style.setProperty('--sg-mobile-search-top', search.style.getPropertyValue('--sg-mobile-search-top'));
      overlay.hidden = false;
    }
    document.body.classList.add('sg-search-lock');
    setMobileSearchExpanded(true);
    window.requestAnimationFrame(function () {
      search.classList.add('is-open');
      if (overlay) overlay.classList.add('is-open');
      syncSearchClearButton(search);
      var input = search.querySelector('input[type="search"]');
      if (input) input.focus();
    });
  }

  function closeMobileSearch(returnFocus) {
    var search = getMobileSearch();
    var overlay = getSearchOverlay();
    if (!search || search.hidden) return;

    search.classList.remove('is-open');
    if (overlay) overlay.classList.remove('is-open');
    document.body.classList.remove('sg-search-lock');
    setMobileSearchExpanded(false);
    window.setTimeout(function () {
      if (!search.classList.contains('is-open')) search.hidden = true;
      if (overlay && !overlay.classList.contains('is-open')) overlay.hidden = true;
    }, 240);
    if (returnFocus && mobileSearchLastFocus && mobileSearchLastFocus.focus) mobileSearchLastFocus.focus();
    mobileSearchLastFocus = null;
  }

  function getMobileDrawer() {
    return document.getElementById('sg-mobile-menu');
  }

  function getOpenMobilePanel() {
    return document.querySelector('#sg-mobile-menu [data-sg-menu-panel].is-open');
  }

  function setMobileMenuExpanded(open) {
    document.querySelectorAll('[data-sg-menu-toggle]').forEach(function (button) {
      button.setAttribute('aria-expanded', open ? 'true' : 'false');
    });
  }

  function primeMobileStoneImages() {
    document.querySelectorAll('#sg-mobile-menu .sg-menu-drawer__stones img[loading="lazy"]').forEach(function (image) {
      image.loading = 'eager';
      if (image.complete) return;
      var source = image.currentSrc || image.src;
      if (!source) return;
      var preload = new Image();
      preload.src = source;
    });
  }

  function openMobileDrawer(trigger) {
    var drawer = getMobileDrawer();
    var overlay = document.querySelector('[data-sg-menu-overlay]');
    if (!drawer) return;

    mobileLastFocus = trigger || document.activeElement;
    resetMobilePanel(false);
    drawer.hidden = false;
    if (overlay) overlay.hidden = false;
    document.body.classList.add('sg-drawer-lock');
    setMobileMenuExpanded(true);
    primeMobileStoneImages();
    window.requestAnimationFrame(function () {
      drawer.classList.add('is-open');
      if (overlay) overlay.classList.add('is-open');
    });
  }

  function closeMobileDrawer(returnFocus) {
    var drawer = getMobileDrawer();
    var overlay = document.querySelector('[data-sg-menu-overlay]');
    if (!drawer || drawer.hidden) return;

    resetMobilePanel(false);
    drawer.classList.remove('is-open');
    if (overlay) overlay.classList.remove('is-open');
    document.body.classList.remove('sg-drawer-lock');
    setMobileMenuExpanded(false);
    window.setTimeout(function () {
      if (!drawer.classList.contains('is-open')) drawer.hidden = true;
      if (overlay && !overlay.classList.contains('is-open')) overlay.hidden = true;
    }, 280);
    if (returnFocus && mobileLastFocus && mobileLastFocus.focus) mobileLastFocus.focus();
    mobileLastFocus = null;
  }

  function setInert(element, inactive) {
    if (!element) return;
    if ('inert' in element) element.inert = inactive;
    element.setAttribute('aria-hidden', inactive ? 'true' : 'false');
  }

  function resetMobilePanel(returnFocus) {
    var drawer = getMobileDrawer();
    var root = drawer && drawer.querySelector('[data-sg-menu-panel="root"]');
    var active = getOpenMobilePanel();
    if (!root || !active) return;

    root.hidden = false;
    setInert(root, false);
    active.classList.remove('is-open');
    setInert(active, true);
    active.hidden = true;

    if (returnFocus && mobileOrigin && mobileOrigin.focus) mobileOrigin.focus();
    mobileOrigin = null;
  }

  function openMobilePanel(panelName, trigger) {
    var drawer = getMobileDrawer();
    var root = drawer && drawer.querySelector('[data-sg-menu-panel="root"]');
    var target = drawer && drawer.querySelector('[data-sg-menu-panel="' + panelName + '"]');
    if (!drawer || drawer.hidden || !root || !target) return;

    var active = getOpenMobilePanel();
    if (active && active !== target) resetMobilePanel(false);
    mobileOrigin = trigger;
    target.hidden = false;
    setInert(root, true);
    setInert(target, false);
    root.hidden = true;
    target.classList.add('is-open');
    var back = target.querySelector('[data-sg-menu-back]');
    if (back) back.focus();
  }

  function closeDesktopPanels(returnFocus) {
    var activeTrigger = null;
    document.querySelectorAll('[data-sg-desktop-menu-toggle][aria-expanded="true"]').forEach(function (trigger) {
      activeTrigger = trigger;
      trigger.setAttribute('aria-expanded', 'false');
    });
    document.querySelectorAll('[data-sg-desktop-panel]').forEach(function (panel) {
      panel.hidden = true;
    });
    if (returnFocus && activeTrigger && activeTrigger.focus) activeTrigger.focus();
  }

  function toggleDesktopPanel(trigger) {
    var panelName = trigger.getAttribute('data-sg-desktop-menu-toggle');
    var panel = document.querySelector('[data-sg-desktop-panel="' + panelName + '"]');
    if (!panel) return;
    var isOpen = trigger.getAttribute('aria-expanded') === 'true';
    closeDesktopPanels(false);
    if (!isOpen) {
      panel.hidden = false;
      trigger.setAttribute('aria-expanded', 'true');
    }
  }

  document.addEventListener('click', function (event) {
    var searchToggle = event.target.closest('[data-sg-search-toggle]');
    if (searchToggle) {
      event.preventDefault();
      openMobileSearch(searchToggle);
      return;
    }

    if (event.target.closest('[data-sg-search-close]')) {
      event.preventDefault();
      closeMobileSearch(true);
      return;
    }

    var searchClear = event.target.closest('[data-sg-search-clear]');
    if (searchClear) {
      event.preventDefault();
      var searchInput = getMobileSearch() && getMobileSearch().querySelector('input[type="search"]');
      if (searchInput) {
        searchInput.value = '';
        syncSearchClearButton(getMobileSearch());
        searchInput.focus();
      }
      return;
    }

    if (event.target.closest('[data-sg-search-overlay]')) {
      closeMobileSearch(true);
      return;
    }

    var openSearch = getMobileSearch();
    if (openSearch && !openSearch.hidden && !event.target.closest('#sg-mobile-search')) {
      closeMobileSearch(false);
    }

    var mobileToggle = event.target.closest('[data-sg-menu-toggle]');
    if (mobileToggle) {
      event.preventDefault();
      openMobileDrawer(mobileToggle);
      return;
    }

    var mobileOpen = event.target.closest('[data-sg-menu-open]');
    if (mobileOpen) {
      event.preventDefault();
      openMobilePanel(mobileOpen.getAttribute('data-sg-menu-open'), mobileOpen);
      return;
    }

    if (event.target.closest('[data-sg-menu-back]')) {
      event.preventDefault();
      resetMobilePanel(true);
      return;
    }

    if (event.target.closest('[data-sg-menu-close]') || event.target.closest('[data-sg-menu-overlay]')) {
      closeMobileDrawer(true);
      return;
    }

    var desktopTrigger = event.target.closest('[data-sg-desktop-menu-toggle]');
    if (desktopTrigger) {
      event.preventDefault();
      toggleDesktopPanel(desktopTrigger);
      return;
    }

    if (!event.target.closest('.sg-header')) closeDesktopPanels(false);
  });

  document.addEventListener('change', function (event) {
    var field = event.target.closest('#SgMenuLocalizationForm select');
    if (field && field.form) field.form.submit();
  });

  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    var search = getMobileSearch();
    if (search && !search.hidden) {
      event.preventDefault();
      event.stopImmediatePropagation();
      closeMobileSearch(true);
      return;
    }
    var drawer = getMobileDrawer();
    if (drawer && !drawer.hidden) {
      event.preventDefault();
      event.stopImmediatePropagation();
      closeMobileDrawer(true);
      return;
    }
    if (document.querySelector('[data-sg-desktop-menu-toggle][aria-expanded="true"]')) {
      event.preventDefault();
      event.stopImmediatePropagation();
      closeDesktopPanels(true);
    }
  }, true);

  document.addEventListener('input', function (event) {
    if (event.target.matches('#sg-mobile-search input[type="search"]')) syncSearchClearButton(getMobileSearch());
  });

  window.addEventListener('resize', function () {
    var search = getMobileSearch();
    var overlay = getSearchOverlay();
    if (!search || search.hidden) return;
    positionMobileSearch(search);
    if (overlay) overlay.style.setProperty('--sg-mobile-search-top', search.style.getPropertyValue('--sg-mobile-search-top'));
  });
}());

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sg-main-collection"]) return;
  try {
    
/* Filteren zonder de pagina te herladen.

   De chips en de filterlinks blijven gewone links: zonder JavaScript werkt
   alles nog en de URL blijft deelbaar. Met JavaScript halen we alleen deze
   sectie opnieuw op via de Section Rendering API (?section_id=) en wisselen we
   de inhoud om. De hero, de header en de rest van de pagina blijven staan.

   De listener hangt aan document, niet aan de sectie zelf: na het omwisselen
   is de oude inhoud weg en zou een listener daarop verdwijnen. */
(function () {
  if (window.sgCollectionFilterReady) return;
  window.sgCollectionFilterReady = true;

  function hostOf(el) {
    return el.closest('.shopify-section');
  }

  async function swap(host, url, push) {
    var id = host.id.replace('shopify-section-', '');
    var target = new URL(url, window.location.origin);
    var fetchUrl = new URL(target.href);
    fetchUrl.searchParams.set('section_id', id);

    host.setAttribute('aria-busy', 'true');
    try {
      var res = await fetch(fetchUrl.href, { headers: { 'X-Requested-With': 'fetch' } });
      if (!res.ok) throw new Error(res.status);
      var doc = new DOMParser().parseFromString(await res.text(), 'text/html');
      var fresh = doc.getElementById('shopify-section-' + id) || doc.body;
      document.dispatchEvent(new CustomEvent('sg:collection-swap'));
      host.innerHTML = fresh.innerHTML;
      if (push) window.history.pushState({ sgFilter: true }, '', target.href);
      var top = host.getBoundingClientRect().top;
      if (top < 0) window.scrollTo({ top: window.scrollY + top - 12, behavior: 'smooth' });
    } catch (err) {
      window.location.href = target.href;   /* bij twijfel gewoon navigeren */
    }
    host.removeAttribute('aria-busy');
  }

  document.addEventListener('click', function (event) {
    if (event.defaultPrevented || event.button !== 0) return;
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
    var link = event.target.closest('a[data-sg-filter]');
    if (!link) return;
    var host = hostOf(link);
    if (!host || !host.id) return;
    event.preventDefault();
    swap(host, link.href, true);
  });

  window.addEventListener('popstate', function () {
    var host = document.querySelector('.shopify-section [data-sg-filter]');
    host = host && hostOf(host);
    if (host) swap(host, window.location.href, false);
  });
})();

  } catch(e) { console.error(e); }
})();
})();
